import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {useTranslation} from 'react-i18next'

const CustomMenuItem = ({Icon, itemId, title, onClick, rowData}) => {
    const {t} = useTranslation()
    return (
        <MenuItem key={`table_action_${itemId}`} onClick={(e) => onClick?.(e, rowData)}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t(`menuItem.${title}`)}</div>
                {Icon && <Icon />}
            </Box>
        </MenuItem>
    )
}

export default CustomMenuItem
